import { Injectable }           from "@angular/core";
import { Http }                 from "@angular/http";

import { Observable }           from "rxjs/Rx";
import "rxjs/add/operator/toPromise";

import { 
    CONSTANT,
    LANGUAGES,
    RESOURCES_DATA,
    RESOURCES_PATH
}                               from "../../_custom";

@Injectable()
export class CtmTranslateService {
    public currentLang: string;

    // inject our translations
    constructor(
        private http: Http
    ) {
    }

    public use(lang: string): void {
        // set current language
        this.currentLang = lang;
    }
    public initialResource(): Promise<Object> {
        return new Promise((resolve, reject) => {
            this.loadResource(0, resolve);
        });
    }
    private loadResource(idx, resolve) {
        if (idx >= LANGUAGES.length) {
            resolve();
            return;
        }
                        
        let lang = LANGUAGES[idx];
        if (RESOURCES_DATA[lang.name] == undefined) {
            this.http.get(`${RESOURCES_PATH}/${lang.name}.json`)
                .toPromise()
                .then((res) => {
                    RESOURCES_DATA[lang.name] = res.json();

                    this.loadResource(idx + 1, resolve);
                })
                .catch(() => {
                    this.loadResource(idx + 1, resolve);
                });
        }
        else {
            this.loadResource(idx + 1, resolve);
        }
    }
    
    public instant(key: string, module: string) {
        // public perform translation
        return this.translate(key, module);
    }
    public get isLanguageEN() {
        return this.currentLang == "en-US";
    }

    private translate(key: string, module: string): string {
        if (this.currentLang == undefined) {
            this.use(CONSTANT.DEFAULT_LANGUAGE);
        }
        
        let translation = key;
        var tran = RESOURCES_DATA[this.currentLang];
        if (tran != undefined) {
            if (module != undefined) {
                var tranf = tran[module];
                if (tranf != undefined) {
                    if (tranf[key] != undefined) {
                        return tranf[key];
                    }
                }
            }
        }

        return translation;
    }
}


// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/_common/services/translate.service.ts